export default function* rootSaga() {
  yield 1;
}
